import { render, staticRenderFns } from "./BankDetailsInputItem.vue?vue&type=template&id=671a2406&scoped=true&"
import script from "./BankDetailsInputItem.vue?vue&type=script&lang=js&"
export * from "./BankDetailsInputItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=671a2406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a2406",
  null
  
)

export default component.exports